module.exports = __webpack_public_path__ + "static/img/2797_phase_function_Paper_Points.c890733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2797_phase_function_Paper_Points.png
// module id = x0XP
// module chunks = 0